<template>
  <div class="container-fluid fitAvailableHeight pt-5 somatoline mt-5 pt-5">
    <loading v-if="loading" />

    <div class="row center mt-5 mb-5">
      <h2 class="text-red Bold widthFull">
        <strong>Recupera password</strong>
      </h2>
    </div>

    <form
      class="forgot-password mt-3"
      id="forgot-form"
      @submit.prevent="forgot"
    >
      <div v-if="!state">
        <div class="form-row justify-content-center">
          <div class="col-md-6 mb-3">
            <label for="email" class="widthFull text-center back-white">
              <h4 class="Medium widthFull text-center">
                Ti manderemo una mail con le istruzioni
              </h4>
              <h4 class="Medium widthFull text-center">
                per ripristinare la tua password
              </h4>
            </label>
          </div>
          <div class="col-12"></div>
          <div class="col-md-4 mb-3">
            <div class="group">
              <input
                type="text"
                v-model="username"
                class="form-control"
                id="username"
                name="username"
                data-vv-as="Email"
                v-validate="{
                  required: true,
                  email: true,
                  temporaryEmail: true,
                  plusIssueEmail: true,
                  max: 56,
                }"
                :class="{
                  'is-invalid': errors.has('username'),
                  valid: !!username,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="username">La tua mail</label>

              <div v-if="errors.has('username')" class="invalid-feedback">
                {{ errors.first("username") }}
              </div>
              <div v-if="error" class="mb-3">
                <span class="formError ml-1">{{ error }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row justify-content-center">
          <div class="col-md-6 mb-3 mt-3 text-center">
            <button class="btn btn-primary mt-3" type="submit">
              Recupera password
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="form-row justify-content-center">
          <div class="col-md-6 mb-3 mt-3 back-white">
            <h4
              for="email"
              class="center Medium pt-3 pb-3 pl-3 pr-3"
              role="alert"
            >
              <p>
                Ti è stata inviata una mail con il link per reimpostare la tua
                password di accesso,controlla nella tua posta in arrivo.
              </p>
              <b>Se non dovessi trovarla controlla anche nella casella spam.</b>
            </h4>
          </div>
        </div>
        <div class="form-row justify-content-center">
          <div class="col-md-6 mb-3 text-center">
            <router-link class="btn btn-primary mt-4" to="/"
              >Continua</router-link
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { AUTH_REQUEST } from "actions/auth";
import { mapGetters, mapState } from "vuex";
import axios from "axios";

export default {
  name: "forgotpassword",
  data() {
    return {
      username: "",
      state: false,
      error: "",
      loading: false,
    };
  },
  methods: {
    forgot: function () {
      const { username } = this;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          var data = {
            email: username,
            table: "utenti",
						 id_platform: process.env.ID_PLATFORM,
            unique_key_db: process.env.UNIQUE_KEY_DB,
            vector_unique_key_db: process.env.ICODE,
          };
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          axios({
            data: {
              data,
            },
            url: process.env.ROOT_API + "api/sendForgotPassEmail",
            method: "POST",
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          })
            .then((resp) => {
              if (resp.data.error == "") {
                this.state = true;
              }
              if (resp.data.error == "email_not_present") {
                this.state = false;
                this.error = process.env.MSG_EMAIL_NOT_FOUND;
              }

              if (resp.data.error == "account_not_confirmed") {
                this.state = false;
                this.error =
                  "Attenzione! Non hai ancora effettuato il primo login. Esegui l`accesso con le credenziali fornite per accettare l`informativa, dopodiché potrai aggiornare la tua passswword";
              }
              this.loading = false;
            })
            .catch((resp) => {
              this.state = false;
              this.error = process.env.MSG_EMAIL_NOT_FOUND;
              this.loading = false;
            });
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "loginerror",
      "isAuthenticated",
      "isProfileLoaded",
    ]),
    ...mapState({
      //login_error: state => `${state.login_error}`,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forgotpassword/index.vue